import useEvent from "react-use-event-hook";

import { isEntityRelationsSupported } from "../constants/entity-relations.constants";
import { DrawerType, RydeUiUnit } from "../models";
import { useDrawers } from "./use-drawers";

export const useOpenRelatedEntitiesDrawer = () => {
  const { openDrawer } = useDrawers();

  const openRelatedEntitiesDrawer = useEvent(
    ({
      entity,
      entityId,
      entityLabel,
    }: {
      entity: RydeUiUnit;
      entityId?: number;
      entityLabel?: string;
    }) => {
      if (!entityId || !isEntityRelationsSupported(entity)) {
        return;
      }

      openDrawer({
        drawerProps: {
          type: DrawerType.RelatedEntities,
          entity,
          entityId,
          entityLabel,
        },
      });
    },
  );

  return { openRelatedEntitiesDrawer, isEntityRelationsSupported };
};
